module.exports = __webpack_public_path__ + "img/07.14c0b22c.jpg";